const localeTokens = {
    s: {
        eng: 's',
        rus: 'с'
    },
    m: {
        eng: 'm',
        rus: 'м'
    },
    h: {
        eng: 'h',
        rus: 'ч'
    }
};

export default function(seconds, locale = 'eng') {
    const secondsNum = parseInt(seconds, 10);
    const _hours = Math.floor(secondsNum / 3600);
    const _minutes = Math.floor(secondsNum / 60) % 60;
    const _seconds = secondsNum % 60;

    const [h, m, s] = [_hours, _minutes, _seconds].map(v => (v < 10 ? '0' + v : v));
    return `~ ${h} ${localeTokens.h[locale]} ${m} ${localeTokens.m[locale]} ${s} ${localeTokens.s[locale]}`;
}
